export const WHATSAPP_ROUTE = 'https://wa.me/+5531991539501/?text=Ol%C3%A1%2C%20%0AVisitei%20o%20site%20da%20Casa%20do%20S%C3%B3ter%20e%20gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es.'
export const INSTAGRAM_ROUTE = 'https://www.instagram.com/casa.do.soter'
export const ACCOMODATIONS_PATH = '/acomodacoes'
export const CASA_PATH = `${ACCOMODATIONS_PATH}/casa-do-soter`
export const BANGALO_PATH = `${ACCOMODATIONS_PATH}/bangalo-do-soter`
export const AGENDA_PATH = '/disponibilidade-e-valores'
export const PRICE_TABLE_PATH = '/disponibilidade-e-valores#prices'
export const CONTACT_PATH = '#contact-location'
